import cn from "classnames"
import parse from "html-react-parser"
import Image from "../../Image"
import Shape from "../../ui/Shape"
import styles from "./BlockQuote.module.scss"

const BlockQuote = ({ data, locale }) => {
  // console.log("BlockQuote", data, locale)

  const { author, quote_text: quoteText, author_position, logo } = data

  const image = logo || author.avatar

  return (
    <div
      className={cn(styles.blockQuote, {
        [styles.blockQuoteRight]: author_position.value === "right",
        [styles.noImage]: !image,
        [styles[`BlockQuote--${locale}`]]: locale,
      })}
    >
      <div className={styles.cite}>
        <div
          className={cn(styles.imageWrapper, {
            [styles.logo]: Boolean(logo),
          })}
          style={{
            aspectRatio: image ? `${image.width}/${image.height}` : null,
          }}
        >
          {image ? (
            <Image
              src={image?.permalink}
              alt={image?.alt}
              fill
              style={{
                objectPosition: image?.focus_css,
              }}
              sizes="(max-width: 767px) 100vw, (max-width: 1023px) 33vw, 33vw"
            />
          ) : (
            <div className={styles.placeholder}>
              <Shape type="rect-vertical-wide" />
              <Shape type="rect-vertical-wide" />
            </div>
          )}
        </div>
        <div className={styles.authorWrapper}>
          <span className={styles.author}>{author?.title}</span>
          <span className={styles.position}>
            {`${author?.position}`}
            {author?.company && (
              <span className="inline">{` bei ${author?.company}`}</span>
            )}
          </span>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.marks}>
          <Shape type="rect-vertical-wide" />
          <Shape type="rect-vertical-wide" />
        </div>
        <blockquote className={styles.quote}>
          {quoteText && <div className={styles.text}>{parse(quoteText)}</div>}
        </blockquote>
      </div>
    </div>
  )
}

export default BlockQuote
